// import { createAxios } from "./base";
import { API } from "aws-amplify";

const index = async (params) => {
  let myInit = { // OPTIONAL
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
    queryStringParameters: params, // OPTIONAL
    headers: {}
  };
  let items = await API.get("InasakuAPI", "/inasaku/season-histories", myInit);
  return items;
};

export default {
  index,
};
